export const Vertical = Object.freeze({
    EnergyPlus: 'E+',
    EnergyD2D: 'Energy Door2Door',
    Energy: 'Energy',
    CML: 'CML'
})